import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import HowItWorks from "@/pages/HowItWorks";
import Platform from "@/pages/Platform";
import Markets from "@/pages/Markets";
import Methodology from "@/pages/Methodology";
import Pricing from "@/pages/Pricing";
import About from "@/pages/About";
import Resources from "@/pages/Resources";
import Faq from "@/pages/Faq";
import RiskDisclosure from "@/pages/RiskDisclosure";
import NotFound from "@/pages/NotFound";
import TradingApp from "@/pages/TradingApp";

function App() {
    return (
        <BrowserRouter>
            <Routes>

                {/* Trading dashboard — standalone, outside marketing layout */}
                <Route path="/dashboard" element={<TradingApp />} />

                <Route element={<Layout />}>
                    <Route path="/" element={<Home />} />
                    <Route path="/how-it-works" element={<HowItWorks />} />
                    <Route path="/platform" element={<Platform />} />
                    <Route path="/markets" element={<Markets />} />
                    <Route path="/methodology" element={<Methodology />} />
                    <Route path="/pricing" element={<Pricing />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/resources" element={<Resources />} />
                    <Route path="/faq" element={<Faq />} />
                    <Route
                        path="/legal/risk-disclosure"
                        element={<RiskDisclosure />}
                    />
                    <Route path="*" element={<NotFound />} />
                </Route>

            </Routes>
        </BrowserRouter>
    );
}

export default App;
